import _ from 'lodash';
import * as actions from 'app/actions/account';

function createState(state, newState) {
  return { ...state, createAccount: newState };
}

function createError(state, error) {
  return createState(state, { error: { [error]: true } });
}

export default function(state = {}, action) {
  switch (action.type) {
    case actions.SET_CREATE_ACCOUNT_PAGE: {
      return Object.assign({}, state, {
        createAccountPage: _.get(action, 'result.fields'),
      });
    }
    case actions.CREATE_ACCOUNT: {
      const { result } = action;
      const { id, errors } = result;
      if (id) {
        // An `id` in the result indicates that the user was properly created.
        return createState(state, { success: true });
      }
      // The user was not created, but the validation handler decided to not
      // throw so that this could provide some specialized error UI.
      const { email: emailErrors } = errors || {};
      if (!emailErrors || !emailErrors.length) {
        // No email errors (we should never get here, but just in case).
        return createError(state, 'generic');
      }
      if (emailErrors.some(err => err.includes('taken'))) {
        // One of the errors indicates the email address was already taken.
        return createError(state, 'userAlreadyExists');
      }
      // The email address was otherwise 'unacceptable'.
      return createError(state, 'unacceptableEmail');
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/account.js